<template>
  <div>
    <EmployeeHeader title="Detalle de Empleado"/>
    <EmployeeForm :employee="employee" @onUpdate="onUpdate"/>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import EmployeeHeader from '../EmployeeHeader'
import EmployeeForm from '../EmployeeForm'

export default {
  name: 'EmployeeDetail',
  components: {
    EmployeeHeader,
    EmployeeForm
  },
  props: {
    employeeId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      employee: {}
    }
  },
  created () {
    this.loadProductData()
  },
  methods: {
    ...mapMutations([
      'toggleProductBtnLoading'
    ]),
    ...mapActions([
      'getEmployee',
      'updateEmployee',
      'setAlertData'
    ]),
    loadProductData () {
      this.getEmployee(this.employeeId)
        .then((res) => {
          if (res.exists) {
            this.employee = { ...res.data(), id: res.id }
          } else {
            console.log('[getEmployee]', '404 Not Found', 'Redirecting...')
            // this.$router.push({ name: 'Employees' })
          }
        })
        .catch((err) => {
          console.log('[getEmployee]')
          console.log(err)
        })
    },
    onUpdate (data) {
      this.toggleProductBtnLoading(true)
      data.updatedAt = new Date().getTime()
      this.updateEmployee(data)
        .then(() => {
          window.scrollTo(0, 0)
          this.toggleProductBtnLoading(false)
          this.setAlertData({
            visible: true,
            msg: 'Empleado Actualizado 🥳',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleProductBtnLoading(false)
          console.log('[updateEmployee]')
          console.log(err)
        })
    }
  }
}
</script>
